import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const screens = [
  {
    id: "landing",
    label: "Club Landing Page",
    url: "https://customer-assets.emergentagent.com/job_sweepstake-builder/artifacts/nqrzakdu_image.png",
    alt: "Branded club predictor landing page with club logo, entry fee and countdown timer",
    caption: "Each club gets a branded landing page with their logo, colours, entry fee, prize details, and a countdown to kick-off.",
  },
  {
    id: "selection",
    label: "Team Selection",
    url: "https://customer-assets.emergentagent.com/job_sweepstake-builder/artifacts/wy1l740g_screen%203.png",
    alt: "Team selection interface showing group-by-group picks with favourites, contenders and long shots",
    caption: "Members pick their teams through an easy, visual interface — works great on mobile too.",
  },
  {
    id: "leaderboard",
    label: "Leaderboard",
    url: "https://customer-assets.emergentagent.com/job_sweepstake-builder/artifacts/6b1jnylc_screen%204.png",
    alt: "Live leaderboard showing player rankings, team progression and total points",
    caption: "When entries close and the tournament kicks off, your page becomes a live leaderboard. Members watch their picks climb the rankings in real time — creating excitement and conversation throughout the event.",
  },
];

export default function ProductShowcase() {
  const [active, setActive] = useState(0);

  return (
    <section
      id="product"
      data-testid="product-showcase-section"
      className="py-10 lg:py-14 px-6 bg-white border-t border-[#1D3557]/5"
    >
      <div className="max-w-6xl mx-auto">
        <p className="font-body text-xs font-bold uppercase tracking-[0.2em] text-[#E63946] mb-4">
          The Product
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight leading-none text-[#1D3557] mb-4">
          See It In Action
        </h2>
        <p className="font-body text-base text-[#1D3557]/55 leading-relaxed max-w-lg mb-6">
          Here's what your club's fundraiser actually looks like. This is our World Cup 2026 Predictor.
        </p>

        <div className="flex gap-2 mb-6 flex-wrap" data-testid="showcase-tabs">
          {screens.map((screen, i) => (
            <button
              key={screen.id}
              onClick={() => setActive(i)}
              className={`px-4 py-2 text-xs font-bold uppercase tracking-widest transition-colors font-body ${
                active === i
                  ? "bg-[#1D3557] text-white"
                  : "bg-[#A8DADC]/20 text-[#1D3557]/50 hover:text-[#1D3557]"
              }`}
              data-testid={`showcase-tab-${screen.id}`}
            >
              {screen.label}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}
          >
            <p className="font-body text-sm text-[#1D3557]/75 mb-4 max-w-lg leading-relaxed font-medium border-l-2 border-[#E63946] pl-4">
              {screens[active].caption}
            </p>
            <div className="border border-[#1D3557]/8 shadow-lg overflow-hidden max-w-4xl" data-testid={`showcase-image-${screens[active].id}`}>
              <img
                src={screens[active].url}
                alt={screens[active].alt}
                className="w-full h-auto"
              />
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Free preview CTA */}
        <div className="mt-8 flex items-center gap-4" data-testid="showcase-preview-cta">
          <a
            href="https://app.targetfunder.com/demo/create"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#E63946] text-white font-bold uppercase tracking-widest px-6 py-3 text-xs hover:bg-[#d32f3c] transition-colors inline-block"
          >
            Try The World Cup 2026 Predictor — Free Demo
          </a>
          <p className="font-body text-xs text-[#1D3557]/40">Takes 30 seconds. No payment, no sign up, no account needed.</p>
        </div>
      </div>
    </section>
  );
}
